import TermsForm from './TermsForm'
export default TermsForm
